export const API = {
  /* ************* App ************** */
  GET_APP_CONFIG_API: 'teacher/v1/app/guest/get-app-config',
  REPORT_ERROR_API: 'teacher/v1/booking/booking/report-booking-error',

  /* ************* Dashboard ************** */
  // Class Detail

  GET_BOOKING_DETAIL_API: 'teacher/v1/booking/booking/get-booking-detail',
  GET_BOOKING_DETAIL_CANCEL_API: 'teacher/v1/booking/booking/get-booking-detail-cancel',
  GET_BOOKING_DETAIL_REJECT_API: 'teacher/v1/booking/booking/get-booking-detail-reject',
  GET_BOOKING_DETAIL_COMPLETED_API: 'teacher/v1/booking/booking/get-class-evaluation',
  GET_DOCUMENT_API: 'teacher/v1/booking/booking/get-document',
  UPDATE_TEACHER_NOTE_API: 'teacher/v1/booking/booking/update-teacher-note',
  GET_HOMEWORK_LABEL_API: 'teacher/v1/booking/booking/get-by-booking-lesson-id',
  EVALUATION_TUTOR_HOMEWORK: 'teacher/v1/booking/booking/teacher-evaluate-tutor-homework',
  GET_ALL_PROGRAM_AND_LEVEL_TEST_API: 'teacher/v1/booking/booking/get-all-program-and-level-test',
  GET_URL_UPLOAD_TUTOR_HOMEWORK_API: 'v1/upload/get-url-upload-tutor-homework',
  DELETE_TUTOR_HOMEWORK_API: 'teacher/v1/booking/booking/delete-tutor-homework',
  RATING_BOOKING_TEST_ONLINE_API: 'teacher/v1/booking/booking/rating-booking-test-online',
  GET_PLACEMENT_TEST_AGE_TAG_API: 'teacher/v1/booking/booking/get-placement-test-age-tag',

  // Classes
  GET_ALL_BOOKING_API: 'teacher/v1/booking/booking/get-all-booking',
  GET_TIMELINE_API: 'teacher/v1/booking/booking/get-timeline-teacher-booking',
  TRIGGER_BBB_SUPPORT: 'teacher/v1/booking/booking/trigger-bbb-support',
  GET_POTENTIAL_BOOKING: 'teacher/v1/booking/potential-booking/get-potential-bookings',
  ACCEPT_BOOKING_POTENTIAL: 'teacher/v1/booking/potential-booking/accept-booking-potential',
  GET_ALL_BOOKING_WAITING_APPROVE: 'teacher/v1/booking/booking/get-all-booking-waiting-approve',
  GET_GROUP_POTENTIAL_BOOKINGS: 'teacher/v1/booking/potential-booking/get-group-potential-bookings',
  COUNT_AVAILABLE_CLASSES: 'teacher/v1/booking/potential-booking/count-available-classes',

  // Income
  GET_INCOME_API: 'teacher/v1/booking/income/get-income-info',
  GET_INCOME_HISTORY_API: 'teacher/v1/booking/income/get-detail-history',
  GET_INCOME_PROGRAM_API: 'teacher/v1/booking/booking/get-teacher-programs',
  GET_BOOKING_HISTORY_API: 'teacher/v1/booking/booking/get-all-booking-history',
  GET_INCOME_LIST_HISTORY_API: 'teacher/v1/booking/income/get-list-history',
  CONFIRM_INCOME_API: 'teacher/v1/booking/income/confirm-income',
  GET_COMPLAINT_API: 'teacher/v1/booking/booking/get-booking-complain-info',
  CREATE_COMPLAINT_API: 'teacher/v1/booking/booking/create-complain',
  GET_COMPLAINT_TICKET_API: 'teacher/v1/booking/booking/get-all-complain',
  GET_COMPLAINT_OVERIVEW_API: 'teacher/v1/booking/booking/get-complain-overview',
  GET_URL_UPLOAD_BOOKING_API: 'teacher/v1/booking/booking/get-url-upload-booking',
  GET_INFO_NOTE_BOOKING_API: 'teacher/v1/booking/booking/get-info-note-booking',

  // Notification
  GET_NOTIFICATION_API: 'teacher/v1/booking/notification/get-notification',
  READ_NOTIFICATION_API: 'teacher/v1/booking/notification/read-notification',

  // Profile
  GET_PROFILE_API: 'teacher/v1/user/user/get-profile',
  UPDATE_PROFILE_API: 'teacher/v1/user/user/update-profile',
  GET_PROFILE_CONFIG_API: 'teacher/v1/user/user/get-profile-config',
  CHANGE_PASSWORD_API: 'teacher/v1/user/user/change-password',
  ACCEPT_PROGRAM_SALARY_API: 'teacher/v1/user/user/accept-program-salary',
  REJECT_PROGRAM_SALARY_API: 'teacher/v1/user/user/reject-program-salary',
  ACCEPT_ALL_PROGRAM_SALARIES_API: 'teacher/v1/user/user/accept-all-program-salary',
  REQUEST_CHANGE_INFORMATION_API: 'teacher/v1/user/user/request-change-information',
  GET_PROGRAM_SALARY_WAITING_SIGNATURE_API:
    'teacher/v1/user/user/get-program-salary-waiting-signature',

  // Setup Schedule
  GET_SCHEDULE_API: 'teacher/v1/booking/booking/get-schedules',
  SET_SCHEDULE_API: 'teacher/v1/booking/booking/set-schedule-status',
  SET_IS_AUTO_REPEAT_CALENDAR_API: 'teacher/v1/booking/booking/set-is-auto-repeat-calendar',

  // Update Profile
  GET_TEACHER_INFO_API: 'teacher/v1/user/user/get-teacher-info',
  UPDATE_PERSONAL_BACKGROUND: 'teacher/v1/user/user/update-personal-background',
  GET_URL_UPLOAD_CONTRACT_API: 'teacher/v1/user/user/get-url-upload-contract',
  PREVIEW_PERSONAL_BACKGROUND_API: 'teacher/v1/user/user/preview-personal-background',
  GET_DISTRICTS_API: 'teacher/v1/user/user/districts',
  GET_WARDS_API: 'teacher/v1/user/user/wards',

  // Dashboard
  LOGOUT_API: 'teacher/v1/user/user/logout',
  GET_NEW_BOOKING_API: 'teacher/v1/booking/booking/get-new-booking',
  GET_SCHEDULE_UP_COMMING_API: 'teacher/v1/booking/booking/get-upcoming',
  ACCEPT_BOOKING_API: 'teacher/v1/booking/booking/accept-booking-by-teacher',
  ACCEPT_BOOKING_DUO_API:
    'teacher/v1/booking/booking/accept-booking-exercise-from-booking-duo-by-teacher',
  REJECT_BOOKING_API: 'teacher/v1/booking/booking/reject-booking-by-teacher',
  CANCEL_BOOKING_API: 'teacher/v1/booking/booking/cancel-booking-by-teacher',
  REMOVE_SCHEDULE_IN_PAST_API: 'teacher/v1/booking/booking/remove-teacher-schedule-in-the-past',
  GET_BOOKING_NOT_EVALUATION_API: 'teacher/v1/booking/booking/get-booking-teacher-not-evaluate',
  GET_NOTIFICATION_NUMBER_UNREAD_API:
    'teacher/v1/booking/notification/get-number-unread-notification',
  GET_HALF_MONTH_INCOME_API: 'teacher/v1/booking/income/half-month-income',
  GET_BOOKING_TEACHER_INFO_API: 'teacher/v1/booking/booking/get-booking-teacher-this-month-info',
  GET_INCOME_WAITING_APPROVE_API: 'teacher/v1/booking/income/get-income-waiting-approve',
  GET_WARNING_API: 'teacher/v1/booking/booking/get-warning',
  PREVIEW_POLICIES_API: 'v1/booking/preview-policies',
  GET_UNREAD_COMMENT_COUNT_API: 'teacher/v1/ticket/ticket/unread-comment-count',
  GET_LIST_REQUEST_API: 'teacher/v1/booking/booking-rival/get-list-request',
  ACCEPT_REQUEST_API: 'teacher/v1/booking/booking-rival/accept-request',
  REJECT_REQUEST_API: 'teacher/v1/booking/booking-rival/reject-request',
  POTENTIAL_ACCEPT_BOOKING_DETAIL: 'teacher/v1/booking/potential-booking/accept-booking',
  CHECK_HAS_BOOKING_TEACHER_SESSION: 'teacher/v1/user/user/check-has-booking-teacher-session',
  GET_LIST_POP_UP_API: 'teacher/v1/booking/booking/list-popup',
  ACCEPT_PRIVACY_POLICY: 'teacher/v1/user/user/accept-privacy-policy',

  /* ************* Guest ************** */
  // Forgot Password
  REQUEST_PASSWORD_API: 'teacher/v1/app/guest/request-password',
  RESET_PASSWORD_API: 'teacher/v1/app/guest/reset-password',

  // Login
  LOGIN_API: 'teacher/v1/app/guest/login',

  /* ************* Join Meeting ************** */
  GET_BOOKING_ACCESS_INFO: 'teacher/v1/booking/booking/get-booking-access-info',
  GET_ACCESS_LINK_API: 'teacher/v1/booking/bbb/get-access-link',

  /* ************* Single Page ************** */
  // Class Waiting
  GET_BOOKING_BY_CLASS_ID: 'v1/booking-guest/get-booking-info-by-class-id',
  BBB_GET_ACCESS_LINK: 'v2/lms/get-access-link',
  // Class Feedback
  GET_INFO_LESSON_API: 'teacher/v1/booking/bbb/get-meeting-info',
  POST_FEEDBACK_API: 'teacher/v1/booking/bbb/feedback-meeting',

  // Force Login
  GET_USER_BY_AUTH_KEY_API: 'teacher/v1/app/guest/get-user-info-by-auth-key',

  // Firebase
  REGISTER_FIREBASE_TOKEN_API: 'teacher/v1/user/user/register-device-token',

  // Message
  UPLOAD_FILE_API: 'teacher/v1/app/guest/upload',
  PUSH_NOTI_MESSAGE_API: 'teacher/v1/chat/chat/push-message',
  CHAT_INIT_ROOM_API: 'teacher/v1/chat/chat/init-room',

  // User
  GET_USER_INFO_API: 'teacher/v1/user/user/get-profile',

  // Conversation
  GET_CONVERSATION_TYPE: 'teacher/v1/chat/chat/get-conversation-type',
  INIT_CONVERSATION: 'teacher/v1/chat/chat/init-conversation',
  CREATE_CONVERSATION: 'teacher/v1/chat/chat/create-conversation',
  END_CONVERSATION: 'teacher/v1/chat/chat/end-conversation',
  REPLY_CONVERSATION: 'teacher/v1/chat/chat/reply-conversation',
  GET_BOOKING_NEED_SUPPORT: 'teacher/v1/booking/booking/get-booking-need-support',
  CONVERSATION_CALLBACK: 'teacher/v1/chat/chat/conversation-callback',

  // Aca training new teacher
  GET_ROOM_ACA_TRAINING: 'teacher/v1/booking/booking/get-room-aca-training',
  GET_ROOM_ACA_TRAINING_TEST: 'teacher/v1/booking/booking/get-room-aca-training-test',
  ASSIGN_TRAINEE_BOOKING: 'teacher/v1/booking/booking/assign-trainee-to-room-aca-training',
  CHANGE_TRAINEE_BOOKING: 'teacher/v1/booking/booking/change-room-aca-training',

  // Current bbb support booking
  CURRENT_BBB_SUPORT_BOOKING: 'teacher/v1/booking/booking/current-bbb-support-booking',
  // Banner
  GET_BANNER: 'learning/v1/app/banner/banner',

  // Popup contract info
  POPUP_CONTRACT_INFO: 'teacher/v1/user/user/popup-contract-info',

  // Request
  GET_LEAVE_REQUEST_API: 'teacher/v1/user/leave-request/leave-request',
  CREATE_ABSENCE_REQUEST_API: 'teacher/v1/user/leave-request/create-absence-request',
  CREATE_OFF_BOARDING_REQUEST_API: 'teacher/v1/user/leave-request/create-off-boarding-request',
  GET_LEAVE_REQUEST_SCHEDULES_API: 'teacher/v1/user/leave-request/schedules',
  GET_APPROVED_BOOKING_API: 'teacher/v1/user/leave-request/approved-booking',
  GET_RESIGN_APPROVED_BOOKING_API: 'teacher/v1/user/leave-request/resign-approved-booking',
  ISSUES_BY_POSITION_API: 'teacher/v1/ticket/issue/issues-by-position',
  GET_URL_UPLOAD_FILE_API: 'teacher/v1/ticket/ticket/url-upload-file',
  CREATE_TICKET_API: 'teacher/v1/ticket/ticket/create-ticket',
  GET_LIST_TICKET_REQUEST_API: 'teacher/v1/ticket/ticket/get-list-ticket',
  GET_LIST_COMMENT_REQUEST_API: 'teacher/v1/ticket/comment/list',
  REMOVE_TICKET_REQUEST_API: 'teacher/v1/ticket/ticket/cancel-ticket',
  RATING_TICKET_REQUEST_API: 'teacher/v1/ticket/ticket/rating-ticket',
  GET_LIST_CATEGORY_REQUEST_API: 'teacher/v1/ticket/issue/issues-by-position',
  CLONE_TICKET_REQUEST_API: 'teacher/v1/ticket/ticket/clone-ticket',
  SET_TICKET_IS_READ_COMMENT_API: 'teacher/v1/ticket/comment/update-is-read-ticket',
  GET_URL_UPLOAD_FILE_REQUEST_API: 'teacher/v1/ticket/comment/url-upload-file',
  POST_COMMENT_REQUEST_API: 'teacher/v1/ticket/comment/comment',
  GET_STUDENT_DETAIL_API: 'learning/v1/booking/default/student-detail',

  // Accept base rate in saver
  ACCEPT_BASE_RATE_API: 'teacher/v1/booking/booking/accept-base-rate-in-saver-time',

  // Reject base rate in saver
  REJECT_BASE_RATE_API: 'teacher/v1/booking/booking/reject-base-rate-in-saver-time',

  GET_CURRENT_TIME: 'teacher/v1/app/app/current-time',
}
